/**
 * Focusable-element discovery — shared by the modal focus trap and the
 * section-focus toggle so both agree on what "focusable" means.
 */

export const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

/** All focusable elements within a container, in DOM order. */
export function getFocusableElements(container: HTMLElement): HTMLElement[] {
  return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR));
}

/**
 * Does this event target own its own text editing?
 *
 * Single-letter and unmodified shortcuts must stand down inside a field, or
 * typing "a" in a series name fires the command instead of inserting a letter.
 * Shared rather than re-declared per hook: every keyboard shortcut in the repo
 * has to answer this question identically, and two hooks disagreeing about what
 * counts as "typing" is the drift pattern STEM-192 exists to prevent.
 */
export function isTextEntry(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
}
